import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShopOpen, setIsShopOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-neon-purple/20' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8">
        {/* Desktop Layout */}
        <div className="hidden lg:flex items-center justify-between h-20">
          <Link to="/" className="flex items-center z-10">
            <img
              src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/cbc12e6e2441c5ee6f286cff30459b30.png"
              alt="Up N' Smoke"
              className="h-12 sm:h-14"
            />
          </Link>

          <div className="flex items-center space-x-10 absolute left-1/2 -translate-x-1/2">
            <Link
              to="/"
              className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide animate-neon-glow"
            >
              Home
            </Link>

            <div 
              className="relative"
              onMouseEnter={() => setIsShopOpen(true)}
              onMouseLeave={() => setIsShopOpen(false)}
            >
              <button
                className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide flex items-center cursor-pointer animate-neon-glow"
              >
                Shop
                <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-300 ${isShopOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isShopOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-black/95 backdrop-blur-md rounded-lg shadow-lg shadow-neon-purple/20 py-2 border border-neon-purple/20">
                  <Link
                    to="/accessories"
                    className="block px-4 py-2 font-rajdhani text-white hover:text-neon-purple hover:bg-neon-purple/10 transition-colors duration-300"
                  >
                    Accessories
                  </Link>
                  <Link
                    to="/shirts"
                    className="block px-4 py-2 font-rajdhani text-white hover:text-neon-purple hover:bg-neon-purple/10 transition-colors duration-300"
                  >
                    Shirts
                  </Link>
                  <Link
                    to="/shop"
                    className="block px-4 py-2 font-rajdhani text-white hover:text-neon-purple hover:bg-neon-purple/10 transition-colors duration-300"
                  >
                    Hats
                  </Link>
                </div>
              )}
            </div>

            <Link
              to="/contact"
              className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide animate-neon-glow"
            >
              Contact
            </Link>
          </div>

          <a
            href="tel:5742187357"
            className="bg-gradient-to-r from-neon-purple to-neon-pink text-white px-4 sm:px-6 py-2 rounded-full font-orbitron text-xs sm:text-sm font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer animate-pulse-glow"
          >
            Call Now
          </a>
        </div>

        {/* Mobile Layout - Centered menu button with logo */}
        <div className="lg:hidden flex items-center justify-center h-20 relative">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="w-12 h-12 flex items-center justify-center text-white hover:text-neon-purple transition-colors cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>
          
          {/* Flashing Call Button - Mobile */}
          <a
            href="tel:5742187357"
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-gradient-to-r from-neon-purple to-neon-pink text-white px-4 py-2 rounded-full font-orbitron text-xs font-bold hover:shadow-lg hover:shadow-neon-purple/50 transition-all duration-300 whitespace-nowrap cursor-pointer animate-pulse-glow"
          >
            Call
          </a>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-md border-t border-neon-purple/20 py-4">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide px-4 py-2 text-center"
              >
                Home
              </Link>
              <Link
                to="/accessories"
                onClick={() => setIsMobileMenuOpen(false)}
                className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide px-4 py-2 text-center"
              >
                Accessories
              </Link>
              <Link
                to="/shirts"
                onClick={() => setIsMobileMenuOpen(false)}
                className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide px-4 py-2 text-center"
              >
                Shirts
              </Link>
              <Link
                to="/shop"
                onClick={() => setIsMobileMenuOpen(false)}
                className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide px-4 py-2 text-center"
              >
                Hats
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="font-orbitron text-white hover:text-neon-purple transition-colors duration-300 text-sm font-semibold tracking-wide px-4 py-2 text-center"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
